// Table column configurations for different monitor tables
// Each export is a factory function that accepts a translation function (t)
import { DateTime } from 'luxon';

export const pickerGroupsColumns = t => [
  { key: 'deviceGroupName', label: t('table.groupName') },
  { key: 'blockName', label: t('table.blockName') },
  { key: 'totalUnits', label: t('table.totalUnits') },
  { key: 'weight', label: t('table.weightKg') },
  { key: 'totalWorkHours', label: t('table.totalWorkHours') },
  { key: 'activeWorkers', label: t('table.activeWorkers') },
  { key: 'averagePerWorker', label: t('table.averagePerWorker') },
  { key: 'averageHourlyRatePerWorker', label: t('table.averageHourlyRatePerWorker') }
];

export const pickerMonitorColumns = t => [
  { key: 'workerId', label: t('table.workerId') },
  { key: 'workerName', label: t('table.workerName') },
  { key: 'blockName', label: t('table.blockName') },
  { key: 'deviceGroupName', label: t('table.groupName') },
  { key: 'totalUnits', label: t('table.totalUnits') },
  { key: 'totalWorkHours', label: t('table.totalWorkHours') },
  { key: 'averageRatePerHour', label: t('table.averageRatePerHour') },
  { key: 'averageRatePerDay', label: t('table.averageRatePerDay') },
  { key: 'workerComments', label: t('table.workerComments') }
];

export const blockMonitorColumns = t => [
  { key: 'blockName', label: t('table.blockName') },
  { key: 'crop', label: t('table.crop') },
  { key: 'variety', label: t('table.variety') },
  { key: 'totalScans', label: t('table.totalScans') },
  { key: 'totalUnits', label: t('table.totalUnits') },
  { key: 'weight', label: t('table.weightKg') },
  { key: 'kgPerPlant', label: t('table.kgPerPlant') },
  { key: 'kgPerSquareMeter', label: t('table.kgPerM2') }
];

export const agroGroupsMonitoringColumns = t => [
  { key: 'groupName', label: t('table.groupName') },
  { key: 'blockName', label: t('table.blockName') },
  { key: 'totalUnits', label: t('table.totalUnits') },
  { key: 'totalWorkHours', label: t('table.totalWorkHours') },
  { key: 'activeWorkers', label: t('table.activeWorkers') },
  { key: 'averagePerWorker', label: t('table.averagePerWorker') },
  { key: 'averageHourlyRatePerWorker', label: t('table.averageHourlyRatePerWorker') }
];

export const agroActionsColumns = t => [
  { key: 'blockName', label: t('table.blockName') },
  { key: 'activityName', label: t('table.activityName') },
  { key: 'units', label: t('table.units') },
  {
    key: 'percentageCompletion',
    label: t('table.percentageCompletion'),
    cell: value => {
      // Don't render the badge for empty values (like in totals row)
      if (!value || value === '') {
        return <span>{value}</span>;
      }

      return (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${
            parseInt(value) === 100
              ? 'bg-green-100 text-green-800'
              : parseInt(value) >= 50
                ? 'bg-yellow-100 text-yellow-800'
                : 'bg-red-100 text-red-800'
          }`}
        >
          {value}
        </span>
      );
    }
  }
];

export const packerGroupsColumns = t => [
  { key: 'groupName', label: t('table.groupName') },
  { key: 'totalPacked', label: t('table.totalPacked') },
  { key: 'workerCount', label: t('table.workerCount') },
  { key: 'avgWeight', label: t('table.avgWeightKg') },
  { key: 'percentageOfTotal', label: t('table.percentageOfTotal') },
  { key: 'avgPerWorker', label: t('table.avgPerWorker') }
];

export const packerMonitorColumns = t => [
  { key: 'workerId', label: t('table.workerId') },
  { key: 'workerName', label: t('table.workerName') },
  { key: 'groupName', label: t('table.groupName') },
  { key: 'totalPacked', label: t('table.totalPacked') },
  { key: 'percentageOfTotal', label: t('table.percentageOfTotal') },
  { key: 'averagePacked', label: t('table.averagePacked') }
];

export const pickingColumns = t => [
  { key: 'blockName', label: t('table.blockName') },
  { key: 'containerName', label: t('table.containerName') },
  { key: 'totalCredits', label: t('table.totalCredits') },
  { key: 'totalContainers', label: t('table.totalContainers') }
];

export const pickingColumnsWithDate = t => [
  { key: 'blockName', label: t('table.blockName') },
  { key: 'containerName', label: t('table.containerName') },
  { key: 'totalCredits', label: t('table.totalCredits') },
  { key: 'totalContainers', label: t('table.totalContainers') },
  {
    key: 'date',
    label: t('table.date'),
    cell: value => {
      return value
        ? DateTime.fromISO(value)
            .setZone('America/Mexico_City')
            .toJSDate()
            .toLocaleDateString('es-MX')
        : '';
    }
  }
];

export const packingColumns = t => [
  { key: 'containerName', label: t('table.containerName') },
  { key: 'stickerType', label: t('table.stickerType') },
  { key: 'totalPacked', label: t('table.totalPacked') },
  { key: 'packerCount', label: t('table.packerCount') }
];

export const packingColumnsWithDate = t => [
  { key: 'containerName', label: t('table.containerName') },
  { key: 'stickerType', label: t('table.stickerType') },
  { key: 'totalPacked', label: t('table.totalPacked') },
  { key: 'packerCount', label: t('table.packerCount') },
  {
    key: 'date',
    label: t('table.date'),
    cell: value => {
      return value
        ? DateTime.fromISO(value)
            .setZone('America/Mexico_City')
            .toJSDate()
            .toLocaleDateString('es-MX')
        : '';
    }
  }
];
